import {AppReflowPageVariantID} from '../constants';
import {addProductPageVariant} from './productPageVariants';
import {EditorSDK, PageRef} from '@wix/platform-editor-sdk';
import {EcomPublicApi} from '../../editor-script/editorScript';
import {Logger as WebBiLogger} from '@wix/web-bi-logger/dist/src/types';
import {addCategoryPageVariant} from './categoryPageVariants';
import {IHttpClient} from '@wix/http-client';

export const addPageVariant = ({
  editorSDK,
  httpClient,
  variantId,
  ecomPublicApi,
  pageRefToDuplicate,
  t,
  webBiLogger,
  errorReporter,
  metaSiteId,
}: {
  editorSDK: EditorSDK;
  httpClient: IHttpClient;
  variantId: AppReflowPageVariantID;
  ecomPublicApi: EcomPublicApi;
  pageRefToDuplicate?: PageRef;
  t: (key: string) => string;
  webBiLogger: WebBiLogger;
  errorReporter: (e: any) => any;
  metaSiteId: string;
}) => {
  if (
    variantId === AppReflowPageVariantID.DuplicateOriginalProductPage ||
    variantId === AppReflowPageVariantID.StartFromBlankProductPage ||
    variantId === AppReflowPageVariantID.DuplicateVariantProductPage
  ) {
    void addProductPageVariant({
      editorSDK,
      httpClient,
      variantId,
      ecomPublicApi,
      pageRefToDuplicate,
      t,
      webBiLogger,
      errorReporter,
      metaSiteId,
    });
  }

  if (
    variantId === AppReflowPageVariantID.DuplicateOriginalCategoryPage ||
    variantId === AppReflowPageVariantID.StartFromBlankCategoryPage ||
    variantId === AppReflowPageVariantID.DuplicateVariantCategoryPage
  ) {
    void addCategoryPageVariant({
      editorSDK,
      httpClient,
      variantId,
      ecomPublicApi,
      pageRefToDuplicate,
      t,
      webBiLogger,
      errorReporter,
      metaSiteId,
    });
  }
};
